export enum JoistType {
  Wood = 0,
  Composite = 1,
  Aluminium = 2,
  Neva = 3,
  ExoticWood = 4,
}
